"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GiveawaySchedulerConfigStatusToJSON = exports.GiveawaySchedulerConfigStatusFromJSONTyped = exports.GiveawaySchedulerConfigStatusFromJSON = exports.GiveawaySchedulerConfigStatus = void 0;
/**
 * Giveaway scheduler configuration status, used for filtering, indicates the current lifecycle status of the Giveaway scheduler configuration
 * @export
 */
exports.GiveawaySchedulerConfigStatus = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE'
};
function GiveawaySchedulerConfigStatusFromJSON(json) {
    return GiveawaySchedulerConfigStatusFromJSONTyped(json, false);
}
exports.GiveawaySchedulerConfigStatusFromJSON = GiveawaySchedulerConfigStatusFromJSON;
function GiveawaySchedulerConfigStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.GiveawaySchedulerConfigStatusFromJSONTyped = GiveawaySchedulerConfigStatusFromJSONTyped;
function GiveawaySchedulerConfigStatusToJSON(value) {
    return value;
}
exports.GiveawaySchedulerConfigStatusToJSON = GiveawaySchedulerConfigStatusToJSON;
